import React from "react";
import {
  Box,
  Typography,
  Stack,
  IconButton,
  Divider,
  LinearProgress,
} from "@mui/material";
import {
  FitnessCenter as TrainingIcon,
  MoreVert as MoreIcon,
} from "@mui/icons-material";
import {
  StyledTrainingCard,
  TrainingHeader,
  TrainingContent,
} from "./StyledComponents";

function StatBlock({ label, value, color = "text.primary" }) {
  return (
    <Box sx={{ textAlign: { xs: "left", sm: "center" }, minWidth: { sm: 72 } }}>
      <Typography variant="caption" color="text.secondary" display="block">
        {label}
      </Typography>
      <Typography variant="h6" fontWeight="bold" color={color}>
        {value}
      </Typography>
    </Box>
  );
}

const TrainingStatisticsCard = ({
  totalWorkouts,
  completedWorkouts,
  weeklyWorkouts,
  completionRate,
}) => {
  const remaining = totalWorkouts - completedWorkouts;

  return (
    <StyledTrainingCard>
      <TrainingHeader>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <TrainingIcon color="primary" sx={{ fontSize: 28 }} />
          <Typography variant="h6" fontWeight="bold">
            Training Statistics
          </Typography>
        </Stack>
        <IconButton size="small" aria-label="Training statistics actions">
          <MoreIcon />
        </IconButton>
      </TrainingHeader>
      <TrainingContent>
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={2.5}
          alignItems={{ md: "center" }}
          justifyContent="space-between"
        >
          <Box sx={{ flex: { md: "1 1 220px" }, minWidth: 0, maxWidth: { md: 360 } }}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ mb: 1 }}
            >
              <Typography variant="body2" color="text.secondary">
                Completion rate
              </Typography>
              <Typography variant="h5" fontWeight="bold" color="primary">
                {completionRate}%
              </Typography>
            </Stack>
            <LinearProgress
              variant="determinate"
              value={Number(completionRate)}
              sx={{
                height: 8,
                borderRadius: 4,
                backgroundColor: "grey.200",
                "& .MuiLinearProgress-bar": {
                  borderRadius: 4,
                },
              }}
            />
          </Box>

          <Divider
            orientation="vertical"
            flexItem
            sx={{ display: { xs: "none", md: "block" } }}
          />
          <Divider sx={{ display: { xs: "block", md: "none" } }} />

          <Stack
            direction="row"
            flexWrap="wrap"
            spacing={{ xs: 2, sm: 3 }}
            useFlexGap
            justifyContent={{ xs: "flex-start", md: "space-evenly" }}
            alignItems="flex-start"
            sx={{ flex: { md: "2 1 auto" }, py: { xs: 0, md: 0.5 } }}
          >
            <StatBlock label="Total workouts" value={totalWorkouts} />
            <StatBlock
              label="Completed"
              value={completedWorkouts}
              color="success.main"
            />
            <StatBlock
              label="Remaining"
              value={remaining}
              color="warning.main"
            />
            <StatBlock
              label="This week"
              value={weeklyWorkouts}
              color="info.main"
            />
          </Stack>
        </Stack>
      </TrainingContent>
    </StyledTrainingCard>
  );
};

export default TrainingStatisticsCard;
